import { useContext } from "react";
import { Navigate, useLocation } from "react-router-dom";
import constants from "../../constants";
import foward from "../../helpers/fowardUrl";
import { AuthContext } from "../../providers/Auth";

interface PrivateRouteProps {
  children: React.ReactNode;
}

const Component = ({ children }: PrivateRouteProps) => {
  const { user } = useContext(AuthContext);
  const location = useLocation();
  const hasExpertProfile = !!sessionStorage.getItem("hasExpertProfile");
  const redirectUrl = foward.getFowardUrl();

  if (!user) {
    foward.setUrl(window.location.href);
    return (
      <Navigate
        to={
          hasExpertProfile
            ? constants.urls.expert.signin.url
            : constants.urls.subscriber.signin.url
        }
        replace
        state={{ from: location }}
      />
    );
  }

  if (!!redirectUrl) {
    foward.goFoward();
    return null;
  }

  return <>{children}</>;
};

export default Component;
